import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {
  HttpClient,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AppLoadingService } from '../common/loading.service';

@Injectable()
export class NotificationsService {
  hostUrl: any = environment.API_BASE_URL;
  public token: string;

  urlToGetNotifications: any = this.hostUrl + 'api/getNotifications';
  urlToGetCardsVisibleInNextHour: any = this.hostUrl + 'api/getCardsVisibleInHour';
  urlToGetLastAssignedCards: any = this.hostUrl + 'api/getLastAssignedCards';
  urlToUpdateNotification: any = this.hostUrl + 'api/updateNotification';

  constructor(private _http: HttpClient) {}

  getNotifications(data: any): Observable<any> {
    return this._http.post(this.urlToGetNotifications, data).map((res: Response) => res);
  }
  getCardsVisibleInNextHour(data: any): Observable<any> {
    return this._http.post(this.urlToGetCardsVisibleInNextHour, data).map((res: Response) => res);
  }
  getLastAssignedCards(data: any): Observable<any> {
    return this._http.post(this.urlToGetLastAssignedCards, data).map((res: Response) => res);
  }
  updateNotification(data: any): Observable<any> {
    return this._http.post(this.urlToUpdateNotification, data).map((res: Response) => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/notifications.service.ts